import { NgModule } from '@angular/core';

import { SharedModule } from '@app/shared';
import { ProjectGroupItemComponent } from './project-group-item/project-group-item.component';
import { ProjectGroupsComponent } from './project-groups.component';

@NgModule({
    imports: [SharedModule],
    declarations: [
        ProjectGroupItemComponent,
        ProjectGroupsComponent
    ],
    entryComponents: [ProjectGroupsComponent],
    exports: [ProjectGroupsComponent]
})
export class ProjectGroupsModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/usersRolesManagement/advancedManagement/project-groups/project-groups.module.ts